import React, { forwardRef } from 'react'
import classNames from 'classnames'

import './TextArea.scss'

/**
 * @import import { TextArea } from '@/components/forms/TextArea'
 * @param {object} props
 * @param {boolean} [props.autoResize] Grows with its content (`field-sizing: content`); browsers ignore `rows` while it is set, so pass a `min-height` in CSS for a resting height
 * @param {boolean} [props.error] Critical border and ring, matching field error styling
 * @param {number} [props.rows] Defaults to 3 (Semantic's default; the native default is 2). Pass `null` to render no rows attribute
 */
export const TextArea = forwardRef(function TextArea(
  { autoResize = false, className, error = false, rows = 3, ...props },
  ref
) {
  return (
    <textarea
      className={classNames('text-area', { 'auto-resize': autoResize, error }, className)}
      rows={rows}
      ref={ref}
      {...props}
    />
  )
})
